import { render } from "./field_context_submenu.vue?vue&type=template&id=33bf021b"
import script from "./field_context_submenu.vue?vue&type=script&lang=js"
export * from "./field_context_submenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__